/*global __CLIENT__*/
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { Map } from 'immutable';
import classNames from 'classnames';

//import ActivityItem from '../components/ActivityItem';
import '../styles/NotificationContainer.css';

export default class NotificationBox extends Component {
  static propTypes = {
    notifications: PropTypes.instanceOf(Map).isRequired,
    dismiss: PropTypes.func.isRequired,
    bar: PropTypes.bool,
    type: PropTypes.node
  }

  render() {
    const {notifications, type, dismiss, bar, modal} = this.props;
    let types = !Array.isArray(type) ? [type] : type;

    let result = types.map(function(type, idx){
      if(!notifications.has(type)){
        return [];
      }

      let classes = {
        notification: true,
        notificationItem: true,
      };

      classes['bg-' + ((type === 'error') ? 'danger' : type)] = true;

      return (
        <div key={idx}>
          <ul className="notifications-list">
          {
            notifications.get(type).map(function(notification, notificationIdx){
              return <li key={notificationIdx} className={classNames(classes)} >
                <div className="notification-wrapper">
                  <p className="notification-text">{notification.get('message')}</p>
                  <i onClick={() => dismiss({type, notificationIdx})} className="close-icon fa fa-times"/>
                </div>
              </li>;
            })
          }
          </ul>
        </div>
      );
    });

    let cx = {
      active: (notifications.size),
      inactive: (!notifications.size),
      bar: (bar === true),
      "modal-popup": (modal === true),
      "modal-bar": (!bar && !modal)
    }

    let closeButton = (modal === true) ? '' : <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={dismiss}><span aria-hidden="true">&times;</span></button>;
    // if(modal === true && notifications.size) setTimeout(dismiss, 2000);
    return (
      <div className={classNames(cx)}>
        {closeButton}
        {result}
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/components/NotificationBox.js